<template>
  <div id="footer">
    <div class="container">
      <div v-if="$route.name == 'drafters'" class="row">
        <div class="col-lg-6 col-md-6 col-sm-6">
          <!-- <div class="w-330"> -->
          <a class="logo" href="https://unatlib.ru"><img src="@/assets/logo.png"></a>
          <!-- </div> -->
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 text-start">
          <div class="w-330 requisites">
            <ul>
              <li>
                <h5 class="text-start"><b-icon-geo-alt-fill variant="danger"></b-icon-geo-alt-fill> Ижевск, Советская,
                  11</h5>
              </li>
              <li>
                <h5 class="text-start"><b-icon-telephone-fill variant="info"></b-icon-telephone-fill> +7 (3412) 65-22-71
                </h5>
              </li>
              <li>
                <h5 class="text-start"><b-icon-envelope-fill variant="warning"></b-icon-envelope-fill> <a
                    href="mailto:priemnaya@naclib.udmr.ru" target="_blank">priemnaya@naclib.udmr.ru</a></h5>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="$route.name != 'drafters'" class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <!-- <div class="w-330"> -->
          <a class="logo2" href="https://unatlib.ru"><img src="@/assets/logo2.png"></a>
          <!-- </div> -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <!-- <div class="w-330"> -->
          <ul>
            <li>
              <h5 class="text-center">©АУК УР «Национальная библиотека УР», {{ getDate() }}</h5>
            </li>
          </ul>
          <!-- </div> -->
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  methods: {
    getDate() {
      return new Date().getFullYear()
    }
  }
}
</script>
<style>
.logo {
  float: none !important;
  margin: 0 auto;
  text-align: center !important;
}

.logo2 {
  float: none;
  margin: 0 auto;
  text-align: center;
}

.logo2 img {
  max-width: 100%;
}

.requisites {
  text-align: center;
  margin: 0 auto;
  padding-left: 10px;
}

a img {
  text-align: center;
  float: none !important;
}

#footer {
  margin-top: 160px;
  padding: 0;
  display: block;
  width: 100%;
  /* height: 300px; */
  /* background-color: #323335;
  color: #ffffff; */
}

li {
  list-style-type: none;
}

#footer ul {
  margin: 0;
  padding-top: 30px;
}

/* .social {
  padding-top: 30px;
} */

li img {
  display: inline;
}

.social span {
  display: block;
}

#footer img {
  margin: 0;
  cursor: pointer;
}

/* #footer a {
  text-decoration: none;
  color: #f4808c;
} */

#footer a:hover {
  color: #efc6ca;
}

.w-330 {
  min-width: 320px;
  max-width: 340px;
}

@media (min-width: 575px) {
  .logo {
    float: right !important;
  }
  .logo2 img {
  max-width: 400px;
}
  .requisites {
    text-align: left;
    margin: 0;
    padding-left: 0;
    padding-top: 15px;
  }
}

@media (min-width: 992px) {
  .col-lg-3 {
    flex: 0 0 auto;
    width: 50% !important;
  }
}

@media (min-width: 1200px) {
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25% !important;
  }
}

.social {
  border-radius: 20px;
  padding: 5px;
  margin: 0;
  width: 35px;
  height: 35px;
}
</style>
